import { LoaderFnConfig } from '@frontend/loaders';
import { ClientConfigProductName } from '@frontend/vanilla/core';

export const BetGeneratorLoader: LoaderFnConfig = {
    id: 'bet-generator',
    loaderFn: () => import('./bet-generator.feature'),
    product: ClientConfigProductName.SPORTS,
};
